import axios from 'axios';

// Security site: subscribe the score taker's email to the newsletter. Same endpoint and
// headers as newsletterService.createNewsletter (legacy, unchanged), but the payload is the
// email only.
const subscribeEmail = async (email) => {
  const apiUrl = process.env.VUE_APP_API_URL;
  return axios.post(
    `${apiUrl}/v1/public/crms?source=Newsletter`,
    { email },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-Page-Route': window.location.pathname,
        'X-Page-Title': document.title,
      },
    }
  );
};

export default {
  subscribeEmail,
};
